function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}
class SliderShowSwiper extends HTMLElement {
    constructor() {
        super();
        this.elmSwiper = this.querySelector('.swiper-container');
        var swiper = new Swiper(this.elmSwiper, {
            slidesPerView: 1,
            spaceBetween: 0,
            loop: true,
            autoHeight: false,
            speed: 500,
            pagination: {
              el: ".swiper-pagination",
              clickable: true,
            },
            // Navigation arrows
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            }
        });
    }
}
customElements.define("swiper-slideshow", SliderShowSwiper);
class SlideTestimonialsSection extends HTMLElement {
    constructor() {
        super();
        this.elmSwiper = this.querySelector('.swiper-container');
        var swiper = new Swiper(this.elmSwiper, {
            slidesPerView: 4,
            spaceBetween: 0,
            loop: true,
            speed: 500,
            autoHeight: false,
            pagination: {
              el: ".swiper-pagination",
              clickable: true,
            },
            // Navigation arrows
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            }
        });
    }
}
customElements.define("slide-testimonials", SlideTestimonialsSection);
class SlideTestimonialsSectionTablet extends HTMLElement {
    constructor() {
        super();
        this.elmSwiper = this.querySelector('.swiper-container');
        var swiper = new Swiper(this.elmSwiper, {
            slidesPerView: 2,
            spaceBetween: 0,
            loop: true,
            autoHeight: false,
            pagination: {
              el: ".swiper-pagination",
              clickable: true,
            },
            // Navigation arrows
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            }
        });
    }
}
customElements.define("slide-testimonials--tablet", SlideTestimonialsSectionTablet);

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch(e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();

    const previousValue = this.input.value;
    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach(submenu => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this, false)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.pagerButtons = this.querySelectorAll('.slider-pager-number');
    this.pagerButtons.forEach((b) => {
      b.addEventListener('click', this.onPagerButtonClick.bind(this));
    });

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.renderDots();
    this.update();
  }

  renderDots() {
    if (this.querySelectorAll('.slider-pagination').length) {
      return;
    }
    var self = this,
      htmlStr = '<div class="slider-pagination">';
    for (var i = 1; i <= self.totalPages; i++) {
      var classSelected = i == 1 ? 'selected' : '';
      htmlStr += '<button type="button" data-step="' + i + '" class="slider-pager-number ' + classSelected + '">' + i + '</button>';
    };
    htmlStr += '</div>';

    var element = document.createDocumentFragment(),
        temp = document.createElement('div');
    temp.innerHTML = htmlStr;
    while (temp.firstChild) {
        element.appendChild(temp.firstChild);
    }
    this.insertBefore(element, this.querySelector('#Slider-card-collection'));
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
        currentPage: this.currentPage,
        currentElement: this.sliderItemsToShow[this.currentPage - 1]
      }}));
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onPagerButtonClick(event) {
    event.preventDefault();
    let page = parseInt(event.currentTarget.dataset.step);
    let curPage = parseInt(this.currentPageElement.textContent);
    let isNext = curPage < page ? false : true;

    this.pagerButtons.forEach((b) => {
      b.classList.remove('selected');
    });
    event.currentTarget.classList.add('selected');

    if (curPage != page) {
      this.slideScrollPosition = isNext ? this.slider.scrollLeft + ((page - curPage) * this.sliderItemOffset)
        : this.slider.scrollLeft - ((curPage - page) * this.sliderItemOffset);
      this.slider.scrollTo({
        left: this.slideScrollPosition
      });
    }

  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderItemOffset) : this.slider.scrollLeft - (step * this.sliderItemOffset);
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length) linkElements.forEach(button => {
          button.removeAttribute('tabindex');
        });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length) linkElements.forEach(button => {
          button.setAttribute('tabindex', '-1');
        });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
    this.updateOptions();
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    mediaGalleries.forEach(mediaGallery => mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true));

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
    const selected = document.querySelectorAll('.js-swatch-label');
    if(selected) {
      selected.forEach(function(item) {
        item.classList.remove('selected');
      })
    }
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
    const possibleVariants = this.getVariantData().filter(variant => variant.option1 === this.options[0]);
    const singleVariant = this.getVariantData().filter(variant => variant.option1);
    const option2 = this.getVariantData().filter(variant => variant.option2);

    if(option2 == ''){
      singleVariant.map(function(variant, index) {
        const input = document.querySelector(`[value="${variant.option1}"]`);
        if(!variant.available) {
          input.classList.add('unavailable');
          // input.setAttribute('disabled', 'disabled');
        } else {
          input.classList.remove('unavailable');
          // input.removeAttribute('disabled');
        }
      })
    } else {
      for (let index = 0; index < possibleVariants.length; index++) {
        const variant = possibleVariants[index]
        const input = document.querySelector(`[value="${variant.option2}"]`);
        if (!variant.available) {
          input.classList.add('unavailable');
          // input.setAttribute('disabled', 'disabled');
        } else {
          input.classList.remove('unavailable');
          // input.removeAttribute('disabled');
        }
      }
    }
  }
}

customElements.define('variant-radios', VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch(e => {
          console.error(e);
        });
    }

    new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 400px 0px'}).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);

function cartdrawerFreeShippingNote() {
  let shippingEls = document.querySelectorAll(
    '.minicart_shipping.show-progression-shipping'
  );
  shippingEls.forEach((shippingEl) => updateFreeShippingNote(shippingEl));
}

function updateFreeShippingNote(shippingEl) {
  let titleProcessEl = shippingEl.querySelector('.title--process');
  let titleSuccessEl = shippingEl.querySelector('.title--success');
  let totalLeftEl = shippingEl.querySelector('.total-left');
  let shippingProgressEl = shippingEl.querySelector('.shipping--progress');
  const formatter = new Intl.NumberFormat(Shopify.locale, {
    style: 'currency',
    currency: Shopify.currency.active == 'AUD' ? 'USD' : Shopify.currency.active,
  });
  if (
    parseInt(shippingEl.dataset.shipping) > parseInt(shippingEl.dataset.total)
  ) {
    titleProcessEl.classList.add('active');
    titleSuccessEl.classList.remove('active');
    let totalLeft = `${formatter.format(
      parseInt(shippingEl.dataset.shipping) -
        parseFloat(shippingEl.dataset.total)
    )}`;
    totalLeftEl.innerHTML = totalLeft;
    shippingProgressEl.style.width = `${
      (parseFloat(shippingEl.dataset.total) /
        parseInt(shippingEl.dataset.shipping)) *
      100
    }%`;
  } else {
    titleProcessEl.classList.remove('active');
    titleSuccessEl.classList.add('active');
    shippingProgressEl.style.width = '100%';
  }
}
cartdrawerFreeShippingNote();

function upsellAddToCart(el) {
  let data = {
    quanity: 1,
    id: el.dataset.id,
    sections: 'cart-drawer,cart-icon-bubble',
  };
  const config = fetchConfig('javascript');
  config.headers['X-Requested-With'] = 'XMLHttpRequest';
  config.body = JSON.stringify(data);
  config.method = 'POST';
  fetch(Shopify.routes.root + 'cart/add.js', config)
    .then((response) => response.json())
    .then((response) => {
      if (response.status) {
        alert(response.description);
        return;
      }
      document.querySelector('cart-drawer').renderContents(response);
    })
    .catch((e) => {
      console.error(e);
    });
}

// change background when click forgot-password
const loginContent = document.querySelector('.js-login-content');
const registerContent = document.querySelector('.js-register-content');
const forgotBtn = document.querySelector('.js-forgot-password');
const recover = document.querySelector('#recover');
if(forgotBtn) {
  forgotBtn.addEventListener('click', function(){
    if (recover.style.display != 'none'){
      loginContent.classList.add('change-background');
    }
  });
}
window.addEventListener('load', function(){
  if(window.location.href.includes('#recover')){
    loginContent.classList.add('change-background');
  }

  if(document.querySelectorAll('.element--flex')){
    document.querySelectorAll('.element--flex').forEach((contentImgEl) => {
      let countItems = contentImgEl.querySelectorAll('img').length;

        contentImgEl.querySelectorAll('img').forEach((i) => {
          var div = document.createElement('div');
          div.setAttribute('class', 'img-wrapper');
          div.insertAdjacentElement('beforeEnd', i);
          contentImgEl.insertAdjacentElement('beforeEnd', div);
        });
    });
  }



    document.querySelectorAll('iframe').forEach((iframeEl) => {
      if (iframeEl.getAttribute('src') && (iframeEl.getAttribute('src').includes('youtube') || iframeEl.getAttribute('src').includes('vimeo'))){
        const parentDiv = iframeEl.parentNode;
        const wrapperDivIframe = document.createElement("div");
        wrapperDivIframe.setAttribute('class', 'video-wrapper');
        wrapperDivIframe.insertAdjacentElement('beforeEnd', iframeEl);
        parentDiv.insertAdjacentElement('beforeEnd', wrapperDivIframe);
      }

    });


});


const cancelForgotBtn = document.querySelector('.js-back-to-login');
if(cancelForgotBtn) {
  cancelForgotBtn.addEventListener('click', function(){
    window.history.back();
    loginContent.classList.remove('change-background');
  });
}

// Go back button
const backBtn = document.querySelector('.js-btn-back');
if (backBtn) {
  backBtn.addEventListener('click', () => {
    if (sessionStorage.getItem('currentLink')){
      window.location.href = sessionStorage.getItem('currentLink');
    }else{
      window.location.href = window.location.origin;
    }
  });
}

const accountBtn = document.querySelector('.site__header__account');
accountBtn.addEventListener('click', function(e){
  e.preventDefault();
  sessionStorage.setItem("currentLink", window.location.href);
  window.location.href = e.target.closest('.site__header__account').getAttribute('href');
});

// remove animation when submit error login
if(document.querySelectorAll('.form__message')){
  document.querySelectorAll('.form__message').forEach((errorMessage) => {
    if(errorMessage.style.display != 'none'){
      if(loginContent){
        console.log(loginContent);
        loginContent.classList.remove('animated', 'fadeInUpBig');
      } else if (registerContent) {
        console.log(registerContent);
        registerContent.classList.remove('animated', 'fadeInUpBig');
      }
    }
  });
}

// Check Sign up into Klaviyo
const checkboxKlaviyo = document.getElementById('myCheckboxKlaviyo');
if(checkboxKlaviyo) {
  checkboxKlaviyo.addEventListener('click', () => {
    if (checkboxKlaviyo.checked == true){
      document.getElementById('Customer_accepts_marketing').value = 'true';
      checkboxKlaviyo.setAttribute('check','checked');
    } else {
      checkboxKlaviyo.setAttribute('check','no-check');
      document.getElementById('Customer_accepts_marketing').value = 'false';
    }
  });
}

// Check Age Under 18 years old
if(document.querySelector('.js-register-btn')){
  document.querySelector('.js-register-btn').addEventListener('click', (e) => {
    // calculateAge();
    // const ageClient = document.getElementById('RegisterForm-birthday').getAttribute('age');
    // if(ageClient < 18) {
    //   e.preventDefault();
    //   const errorMessage = document.querySelector('.form__message.under-18age');
    //   if(errorMessage.style.display = 'none'){
    //     errorMessage.style.display = 'flex';
    //   }
    // }
    var dobInput = document.getElementById("RegisterForm-birthday");
    var dobValue = dobInput.value;
    var dobParts = dobValue.split("/");
    var dobDate = new Date(dobParts[2], dobParts[1] - 1, dobParts[0]);
    var today = new Date();
    const errorMessage = document.querySelector('.form__message.under-18age');

    var age = today.getFullYear() - dobDate.getFullYear();
    var monthDiff = today.getMonth() - dobDate.getMonth();

    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < dobDate.getDate())) {
      age--;
    }

    if(age < 18) {
      e.preventDefault();
      errorMessage.style.display = 'flex';
    } else {
      errorMessage.style.display = 'none';
    }
  });
}


function calculateAge() {
  let birthDate = new Date(document.querySelector('#RegisterForm-birthday').value);
  let birthDateDay = birthDate.getDate();
  let birthDateMonth = birthDate.getMonth();
  let birthDateYear = birthDate.getFullYear();

  let mm = Number(birthDateMonth + 1);
  let dd = birthDate.getDate();
  if (dd < 10) dd = '0' + dd;
  if (mm < 10) mm = '0' + mm;
  let customerNoteDOB = document.querySelector(".customer_DOB-tag");
  customerNoteDOB.value = "DOB: " + dd + "/" + mm  + "/" + birthDateYear;

  let todayDate = new Date();
  let todayDay = todayDate.getDate();
  let todayMonth = todayDate.getMonth();
  let todayYear = todayDate.getFullYear();

  let calculateAge = 0;

  if (todayMonth > birthDateMonth) calculateAge = todayYear - birthDateYear;
  else if (todayMonth == birthDateMonth) {
    if (todayDay >= birthDateDay) calculateAge = todayYear - birthDateYear;
    else calculateAge = todayYear - birthDateYear - 1;
  } else {
    calculateAge = todayYear - birthDateYear - 1;
  }
  document.getElementById('RegisterForm-birthday').setAttribute('age', calculateAge);
}

// Show format date year for birthday field
// if(document.getElementById('RegisterForm-birthday')){
//   const inputDate = document.getElementById('RegisterForm-birthday');
//   inputDate.addEventListener('keyup', (e) => {
//     e.preventDefault();
//     const inputDateValue = document.getElementById('RegisterForm-birthday').value;
//     let date = inputDateValue.split('-');
//     let year = date[0];
//     let month = date[1];
//     let day = date[2];
//     if (year.length > 3) {
//       let lastYear = year.slice(-4);
//       year = lastYear;
//       a = year + '-' + month + '-' + day;
//       document.getElementById('RegisterForm-birthday').value = a;
//     }
//   });
// }

// Show format date for birthday field
// if(document.getElementById('RegisterForm-birthday')){
//   const inputDate = document.getElementById('RegisterForm-birthday');
//   const inputDateShow = document.getElementById('RegisterForm-birthday-show');
//   inputDateShow.value = 'DD' + ' / ' + 'MM' + ' / ' + "YYYY";
//   inputDate.addEventListener('change', () => {
//     let birthday = new Date(document.querySelector('#RegisterForm-birthday').value);
//     let dateDay = birthday.getDate() + 1;
//     let dateMonth = birthday.getMonth() + 1;
//     let dateYear = birthday.getFullYear();
//     if (dateDay || dateMonth || dateYear){
//       inputDateShow.value = dateDay + ' / ' + dateMonth + ' / ' + dateYear;
//     } else {
//       inputDateShow.value = 'DD' + ' / ' + 'MM' + ' / ' + "YYYY";
//     }
//   });
// }

// menu
var body = document.querySelector('body');
document.querySelector('.js-open-menu').addEventListener("click", () => {
  body.classList.add('megamenu-open');})
document.querySelector('.js-close-menu').addEventListener('click', () => {
  body.classList.remove('megamenu-open')
})

// Open Search

document.querySelector('.js-open-search').addEventListener("click", () => {
  body.classList.add('open-search');
  setTimeout(function() {
    document.querySelector('#autocomplete-0-input').focus();
  }, 300);
})
if(document.querySelector(".text-form__fields-phone")){
  document.querySelector(".text-form__fields-phone").addEventListener("keyup", () => {
    document.querySelector(".text-form__fields-phone").value = document.querySelector(".text-form__fields-phone").value.replace(/[^0-9]/g, '');
  })
  document.querySelector(".text-form__fields-phone").addEventListener("blur", () => {
    document.querySelector(".text-form__fields-phone").reportValidity();
  })
}
document.querySelector('.js-close-search').addEventListener('click', () => {
  body.classList.remove('open-search');
   body.classList.add('remove-panel-search');
})

document.querySelector('.search-overlay').addEventListener('click', () => {
  body.classList.remove('open-search');
  body.classList.add('remove-panel-search');
})

// Article
if(document.querySelectorAll('.article-card-wrapper')){
    document.querySelectorAll('.article-card-wrapper').forEach((item) => {
    var contentEl = item.querySelector('[id^="article-card__content-"]');
    var contentText = contentEl.innerText || contentEl.textContent;
    var mins = Math.ceil(contentText.trim().split(/\s+/).length / 5 / 60);
    var mTextLabel = 'Reading time:';
    var mText = mins > 1 ? 'mins' : 'min';
    if (item.querySelector('[id^="reading_time-"]')){
      item.querySelector('[id^="reading_time-"]').innerHTML = mTextLabel + ' ' + mins + ' ' + mText;
    }

  });
}

// Event JS
let contentsWrapper = document.querySelector('.section-banner-history');
if(contentsWrapper){
    let heightContentText = document.querySelector('.section-banner__content.desktop ').offsetHeight;
    let heightBanner = document.querySelector('.section-banner-history ').offsetHeight;
    let heightContentTextMb = document.querySelector('.section-banner__content.mobile ').offsetHeight;
    console.log(heightContentTextMb);
    document.querySelector('.line-wrapper-mb .line-wrapper').style.marginTop =  heightContentTextMb / 2  - 30 + 'px' ;
    document.querySelector('.line-wrapper-mb .line-wrapper').style.height =  heightBanner / 2 - 40 + 'px' ;
    document.querySelector('.line-wrapper-desktop .line-wrapper').style.marginTop =  heightContentText / 2  - 30 + 'px' ;
}
goHistory();
window.addEventListener('resize', goHistory);

function goHistory(){
  let contentsWrapper = document.querySelector('.section-banner-history');
  if(contentsWrapper){
      let heightContentText = document.querySelector('.section-banner__content.desktop ').offsetHeight;
      let heightBanner = document.querySelector('.section-banner-history ').offsetHeight;
      let heightContentTextMb = document.querySelector('.section-banner__content.mobile ').offsetHeight;
      console.log(heightContentTextMb);
      document.querySelector('.line-wrapper-mb .line-wrapper').style.marginTop =  heightContentTextMb / 2  - 30 + 'px' ;
      document.querySelector('.line-wrapper-mb .line-wrapper').style.height =  heightBanner / 2 - 40 + 'px' ;
      document.querySelector('.line-wrapper-desktop .line-wrapper').style.marginTop =  heightContentText / 2  - 30 + 'px' ;
  }
}

function getRandomString(length) {
	var randomChars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
	var result = '';
	for ( var i = 0; i < length; i++ ) {
		result += randomChars.charAt(Math.floor(Math.random() * randomChars.length));
	}
	return result;
}

const articleItems = document.querySelectorAll('.blog-articles__group--item .blog-articles__item');
articleItems.forEach((e) => {
  const style = window.getComputedStyle(e);
  display = style.getPropertyValue("display");
  if(display != 'none') {
    // e.classList.add('is-open');
    e.setAttribute('is-open', 'true');
  }
});
const badgeLabel = document.querySelectorAll('.image-badge');
if(badgeLabel) {
  if(badgeLabel.length > 1) {
    badgeLabel.forEach(function (item) {
      item.style.display = 'none';
    })
  }
}

if (document.querySelector(".js-anchor")) {
  document.querySelector(".js-anchor").addEventListener("click", (e) => {
    e.preventDefault();
    const elm = document.querySelector(".section-rich-text");
    elm.scrollIntoView({behavior: 'smooth', block: 'center'})
  })
}
if (document.querySelector(".anchor-content")) {
  const buttonAchor = document.querySelectorAll(".button-anchor");
  buttonAchor.forEach((item) => {
      item.addEventListener("click", (e) => {
        const element = document.querySelector(item.getAttribute('data-link'));
        const offset = 111;
        const bodyRect = document.body.getBoundingClientRect().top;
        const elementRect = element.getBoundingClientRect().top;
        const elementPosition = elementRect - bodyRect;
        const offsetPosition = elementPosition - offset;
        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });
      });
  });
}
